<template>
   <div>
        <center>
            <h2 class="h3">Categorías</h2>
        </center>
        <div v-if="loading" class="loader"></div>
        <div class="menu-list">
            <ul>
                <li>
                    <a :href="blog_url">Ver Todas</a>
                </li>
                <li v-for="categoria in categorias" :key="categoria.id">
                    <a :href="goUrl(categoria.id)">
                        {{ categoria.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import axios from '../axios'

export default {
    mounted() {
        this.getCategoiras()
        this.blog_url = this.$publicUrl + 'blog/posts'
    },
    data() {
        return {
            loading: false,
            categorias: [],
            blog_url: ''
        }
    },
    methods: {
        goUrl(id_categoria) {
            return this.$publicUrl + 'blog/categories/' + id_categoria
        },
        getCategoiras() {
            this.loading = true
            axios.get('blog/categories').then(response => {
                this.categorias = response.data
                this.loading = false
            }).catch(error => {
                console.log(error.message)
            })
        }
    }
}
</script>